<!-- Native mobile (Android/iOS): split-button with Take Photo / Record Video / Choose from Gallery in the dropdown. -->
<p-splitButton
  *ngIf="showCaptureOptions"
  [label]="label"
  [icon]="buttonIcon"
  [model]="menuItems"
  [disabled]="disabled"
  styleClass="media-capture-split-button"
  (onClick)="onDefaultAction()"
></p-splitButton>

<!-- Web / any other platform: identical plain button to what every surface already had. -->
<button
  *ngIf="!showCaptureOptions"
  pButton
  type="button"
  [label]="label"
  [icon]="buttonIcon"
  [disabled]="disabled"
  (click)="browseFiles()"
></button>

<input
  #browseInput
  type="file"
  [attr.accept]="acceptTypes"
  [multiple]="multiple"
  class="media-capture-hidden-input"
  (change)="onBrowseFilesSelected($event)"
/>
